import { render, staticRenderFns } from "./SetProductSort.vue?vue&type=template&id=3bb2f1f4&scoped=true"
import script from "./SetProductSort.vue?vue&type=script&lang=js"
export * from "./SetProductSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2f1f4",
  null
  
)

export default component.exports